import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

import getStoryCostActions from '../../actions/settings/getStoryCost';

export default createAsyncReducer<any, GenericResponse>(getStoryCostActions);
